import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import TopWhatsAppBar from './components/TopWhatsAppBar';
import Footer from './components/Footer';
import Analytics from './components/Analytics';
import StickyCTA from './components/StickyCTA';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Testimonials from './pages/Testimonials';
import Offers from './pages/Offers';
import ServiceDetail from './pages/ServiceDetail';
import RequestQuote from './pages/RequestQuote';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import './App.css';

export default function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <div className="flex min-h-screen flex-col bg-gray-50">
  <Header />
  <TopWhatsAppBar />
        <main className="flex-1">
          <Analytics />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/request-quote" element={<RequestQuote />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
        </main>
        <Footer />
        <StickyCTA />
      </div>
  </BrowserRouter>
  </HelmetProvider>
  );
}
